import { useContext } from 'react';

import { RouteContext } from 'src/context';
import { STUDIO_POST_CREATE_VALUE } from 'src/routes/onboarding/setup/constants';
import {
  isOnboardingStep,
  isStudioStep,
  OnboardingQueryParams,
} from 'src/routes/onboarding/setup/types';

const trimQueryParam = (value?: string): string | undefined => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : undefined;
};

export const useOnboardingQueryParams = () => {
  const { query } = useContext(RouteContext);
  const {
    prefill_email,
    template_id,
    template_name,
    templateId,
    templateName,
    templateDescription,
    step,
    studio_post_create,
    portal_header,
    portal_url,
    ...queryParams
  } = query as OnboardingQueryParams;

  return {
    prefillEmail:
      prefill_email !== undefined
        ? decodeURIComponent(prefill_email)
        : undefined,
    workspaceTemplateId: template_id,
    workspaceTemplateName: template_name,
    templateId: trimQueryParam(templateId),
    templateName: trimQueryParam(templateName),
    templateDescription: trimQueryParam(templateDescription),
    step: isOnboardingStep(step) ? step : undefined,
    // Studio resume values share the same `step` query param as classic.
    studioStep: isStudioStep(step) ? step : undefined,
    studioPostCreate: studio_post_create === STUDIO_POST_CREATE_VALUE,
    portalHeader: portal_header,
    portalUrl: portal_url,
    ...queryParams,
  } as const;
};
